/* ---------------------------------------------------------------
   Lin & Lore - maattabel op de productpagina

   De markup komt uit snippets/ll-maattabel.liquid, dat via een
   custom_liquid-blok in templates/product.json wordt gerenderd. Liquid
   bepaalt daar welke van de drie tabellen erin staat, op basis van
   product.type met een terugval op de maatwaarden zelf.

   Dit bestand doet drie dingen:
   1. het woord 'Maattabel' verplaatsen naar de regel van de maatkiezer,
      dus tussen de kleurkiezer en de maatknoppen. Staat de bundel
      (ll-bundel-1plus1) op de pagina, dan is die maatkiezer verborgen en
      gaat de link naar de regel boven de keuzevakjes in de bundel
   2. de overlay openen en sluiten
   3. de meetvisual laden zodra iemand naar de link beweegt, niet pas bij
      het klikken

   WAAROM PUNT 1 IN JAVASCRIPT ZIT
   Het thema rendert kleur EN maat samen in een variant_picker-blok, als
   twee <fieldset>-elementen. Een themablok kan er via block_order alleen
   voor of na, nooit tussen.

   WAAROM PUNT 3 ZO WERKT
   De <img> staat in een verborgen overlay. Met loading="lazy" begint zo'n
   afbeelding nooit te laden, want de browser ziet hem niet in beeld komen.
   De URL staat daarom in data-src en data-srcset. Die zetten we op drie
   momenten: bij pointerenter of focus op de link, en als de pagina verder
   klaar is (requestIdleCallback). Dat laatste is er voor mobiel: daar
   bestaat geen hover, dus touchstart komt pas een fractie voor de klik en
   kwam het beeld bijna altijd binnen terwijl het paneel al open stond.
   Het gaat om 11 tot 29 kB, en we slaan het over op een zuinige of trage
   verbinding.

   HERKENNING VAN DE MAATKIEZER
   Het thema geeft de legend van de maatkiezer de class 'size'. Nooit op
   optienaam filteren: dat breekt zodra een product 'Maten' of 'Size' heet.
   --------------------------------------------------------------- */

(function () {
  'use strict';

  var laatsteFocus = null;
  var visualGestart = false;
  var scrollVast = 0;
  var vast = false;

  // Alleen overflow:hidden op <html> houdt een mobiele browser niet tegen:
  // de pagina schuift alsnog en de adresbalk klapt in of uit. Het paneel is
  // in dvh gemeten en verspringt dan halverwege. Body op position:fixed met
  // de scrollpositie als negatieve top houdt het beeld precies staan.
  function vergrendel() {
    if (vast) return;
    scrollVast = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = -scrollVast + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';
    vast = true;
  }

  function ontgrendel() {
    if (!vast) return;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.style.overflow = '';
    vast = false;
    window.scrollTo(0, scrollVast);
  }

  function maatLegend() {
    var legends = document.querySelectorAll('.product-info__option-header');
    for (var i = 0; i < legends.length; i++) {
      if (legends[i].classList.contains('size')) return legends[i];
    }
    return null;
  }

  // De bundel heeft per optie een plek; alleen die in de open optie is
  // zichtbaar, en daar hoort de link.
  function bundelPlek() {
    var plekken = document.querySelectorAll('[data-ll-maat-slot]');
    for (var i = 0; i < plekken.length; i++) {
      if (plekken[i].getClientRects().length) return plekken[i];
    }
    return plekken[0] || null;
  }

  function overlay() { return document.querySelector('[data-ll-maat-modal]'); }

  // Start het laden van de meetvisual. Veilig om vaker aan te roepen.
  function laadVisual() {
    if (visualGestart) return;
    var ov = overlay();
    if (!ov) return;
    var fig = ov.querySelector('.ll-maat__visual');
    if (!fig) return;
    var img = fig.querySelector('img');
    if (!img) { fig.hidden = true; return; }

    var bron = img.getAttribute('data-src');
    var set = img.getAttribute('data-srcset');
    if (!bron && !set) return;

    visualGestart = true;
    img.addEventListener('error', function () { fig.hidden = true; }, { once: true });
    if (set) img.setAttribute('srcset', set);
    if (bron) img.setAttribute('src', bron);
  }

  function open() {
    var ov = overlay();
    if (!ov) return;
    laatsteFocus = document.activeElement;

    // volgorde telt: eerst het beeld op gang brengen en de achtergrond
    // vastzetten, pas daarna tonen. Anders opent het paneel en verschuift
    // het daarna nog.
    laadVisual();
    vergrendel();
    ov.hidden = false;

    // altijd bovenaan beginnen, ook bij een tweede keer openen
    var body = ov.querySelector('.ll-maat__body');
    if (body) body.scrollTop = 0;

    var sluitKnop = ov.querySelector('[data-ll-maat-close]');
    if (sluitKnop) sluitKnop.focus({ preventScroll: true });
  }

  function sluit() {
    var ov = overlay();
    if (!ov) return;
    ov.hidden = true;
    ontgrendel();
    if (laatsteFocus && laatsteFocus.focus) laatsteFocus.focus({ preventScroll: true });
  }

  function plaatsLink() {
    var knop = document.querySelector('[data-ll-maat-open]');
    var doel = bundelPlek() || maatLegend();
    if (!knop || !doel) return;

    if (knop.parentElement !== doel) doel.appendChild(knop);

    // de overlay hoort aan body, anders knipt de productkolom hem af
    var ov = overlay();
    if (ov && ov.parentElement !== document.body) document.body.appendChild(ov);
  }

  function start() {
    plaatsLink();

    // Vooruit laden zodra iemand richting de link beweegt.
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (!e.target || !e.target.closest) return;
        if (e.target.closest('[data-ll-maat-open]')) laadVisual();
      }, { passive: true, capture: true });
    });

    // Mobiel heeft geen hover. Zodra de pagina het rustig heeft, halen we
    // de visual alsnog op, zodat het paneel meteen compleet opent.
    var net = navigator.connection;
    var zuinig = net && (net.saveData || /(^|-)2g$/.test(net.effectiveType || ''));
    if (!zuinig) {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(function () { laadVisual(); }, { timeout: 3000 });
      } else {
        setTimeout(laadVisual, 1500);
      }
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      if (e.target.closest('[data-ll-maat-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-ll-maat-close]')) { e.preventDefault(); sluit(); return; }

      var ov = overlay();
      if (ov && !ov.hidden && e.target === ov) sluit();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var ov = overlay();
      if (ov && !ov.hidden) sluit();
    });

    // Het thema hertekent het formulier bij een variantwissel. Zetten we
    // de link dan niet terug, dan verdwijnt hij na de eerste klik.
    var form = document.querySelector('.product-info__form') || document.body;
    var bezig = false;
    var obs = new MutationObserver(function () {
      if (bezig) return;
      bezig = true;
      setTimeout(function () { plaatsLink(); bezig = false; }, 0);
    });
    obs.observe(form, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();